import { useState, useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';

export const LazyImage = ({ src, blurSrc, alt = '', className, fallbackSrc, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    setLoaded(false);
    setError(false);
  }, [src]);

  const displaySrc = error && fallbackSrc ? fallbackSrc : src;

  return (
    <div className={cn("relative overflow-hidden", className)} {...props}>
      {/* Blur placeholder */}
      {blurSrc && !loaded && (
        <img
          src={blurSrc}
          alt=""
          aria-hidden
          className="absolute inset-0 w-full h-full object-cover scale-110 blur-sm"
          data-testid="blur-placeholder"
        />
      )}
      {/* Actual image */}
      <img
        ref={imgRef}
        src={displaySrc}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => {
          if (!error && fallbackSrc) {
            setError(true);
          } else {
            setLoaded(true);
          }
        }}
        className={cn(
          "w-full h-full object-cover transition-opacity duration-500",
          loaded ? "opacity-100" : "opacity-0"
        )}
        data-testid="lazy-image"
      />
    </div>
  );
};
